/*** statusLightsList.js ***/
/* Project: Pump Panel Simulator
   Descript: Training tool to assist in learing 
   Created: Kendra Wainscott  2022

   list of status lights for StatusLights component
*/

export const statusLightsList = [
  {
    caption: "oil",
    src: require("../../images/governor_imgs/oilCan.png"),
    alt: "oil can icon",
  },
  {
    caption: "eng",
    src: require("../../images/governor_imgs/thermometer.png"),
    alt: "thermometer icon",
  },
  {
    caption: "trans",
    src: require("../../images/governor_imgs/transTemp.png"),
    alt: "trasmission temperature icon",
  },
  {
    caption: "volts",
    src: require("../../images/governor_imgs/volts.png"),
    alt: "automotive battery icon",
  },
];
